import { render, staticRenderFns } from "./InteractionBar.vue?vue&type=template&id=207149d2&"
import script from "./InteractionBar.vue?vue&type=script&lang=js&"
export * from "./InteractionBar.vue?vue&type=script&lang=js&"
import style0 from "./InteractionBar.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports